import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { discordAPI } from "../../../api/apiClient";
import useApi from "../../CustomHooks/useApi";
import { FaDiscord, FaPlus, FaChevronRight } from "react-icons/fa";
import "../../../css/DiscordChannelsSection.css";
import Loading from "../../../Loading";
import { useTripContext } from "../TripContext";
import AddDiscordChannelModal from "./AddDisordChannelModal";

const DiscordChannelsSection = () => {
  const { guid: tripGuid } = useParams();
  const [channels, setChannels] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasLoadedChannels, setHasLoadedChannels] = useState(false);
  const { tripData } = useTripContext();
  const { callApi, isLoading } = useApi();

  const fetchChannels = () => {
    if (!tripGuid) return;
    setHasLoadedChannels(false);
    callApi(() => discordAPI.channels.getChannelsForTrip(tripGuid), (data) => {
      setChannels(data);
      setHasLoadedChannels(true);
    });
  };

  useEffect(() => { fetchChannels(); }, [tripGuid]);

  const usedVariantGuids = channels.flatMap((ch) => ch.variantGuids || []);
  const availableVariants = tripData?.variants.filter((v) => !usedVariantGuids.includes(v.guid)) || [];

  return (
    <div className="discord-section">
      <div className="discord-mobile-title">Discord</div>

      <div className="discord-toolbar">
        {hasLoadedChannels && !isLoading && <button className="discord-create-btn" type="button" onClick={() => setIsModalOpen(true)}><FaPlus /> Utwórz kanał</button>}
      </div>

      {(isLoading || !hasLoadedChannels) ? (
        <Loading text="Ładowanie danych" />
      ) : channels.length === 0 ? (
        <div className="discord-empty">
          <div className="discord-empty-icon"><FaDiscord /></div>
          <strong>Brak kanałów Discord</strong>
          <span>Ta wycieczka nie ma jeszcze żadnego powiązanego kanału.</span>
          <button type="button" onClick={() => setIsModalOpen(true)}><FaPlus /> Utwórz pierwszy kanał</button>
        </div>
      ) : (
        <div className="discord-channel-list">
          {channels.map((ch) => {
            const variantNames = (ch.variantGuids || []).map((guid) => tripData?.variants.find((v) => v.guid === guid)?.name).filter(Boolean);
            return (
              <Link to={`${ch.id}`} key={ch.id} className="discord-channel-card-link">
                <div className="discord-channel-card">
                  
                  <div className="discord-channel-main">
                    <div className="discord-channel-header">#{ch.name}</div>
                    <div className="discord-channel-variants-tags">
                      {variantNames.length > 0 ? variantNames.map((name, idx) => <span key={idx} className="variant-tag">{name}</span>) : <span className="variant-tag variant-tag--all">Cała wycieczka</span>}
                    </div>
                  </div>
                  <FaChevronRight className="discord-channel-chevron" />
                </div>
              </Link>
            );
          })}
        </div>
      )}

      <AddDiscordChannelModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} tripData={tripData} onCreate={(name, variantGuids) => {
        callApi(() => discordAPI.channels.addChannel(tripGuid, { name, creators: [], variantGuids }), () => fetchChannels());
      }} availableVariants={availableVariants} />
    </div>
  );
};

export default DiscordChannelsSection;
